import { useEffect, useState } from "react";
import InfiniteScrollSelect from "../../../components/ui/InfiniteScrollSelect";
import { useAuth } from "../../../hooks/useAuth";

interface Props {
  target: "place" | "offer" | "event";
  onChange: (value: string) => void;
}

export default function NotificationTargets({ target, onChange }: Props) {
  const { isAdmin } = useAuth();
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const offerEndpoint = !isAdmin ? "specials/ours" : "specials/all";

  const inputDetails = {
    place: {
      placeholder: "Sélectionnez un établissement",
      url: "places",
      labelKey: "name",
    },
    event: {
      placeholder: "Sélectionnez un événement",
      url: "events/ours",
      labelKey: "name",
    },
    offer: {
      placeholder: "Sélectionnez une offre",
      url: offerEndpoint,
      labelKey: "title",
    },
  }[target || "place"];

  useEffect(() => {
    setSelectedItem(null);
    onChange("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target]);

  return (
    <InfiniteScrollSelect
      variant="pill"
      key={target}
      isClearable={false}
      getOptionLabel={(option: any) => option[inputDetails.labelKey]}
      getOptionValue={(option: any) => option.id}
      isOptionSelected={(option: any, selectedValue: any[]) =>
        option.id === selectedValue?.[0]?.id
      }
      url={{ path: inputDetails.url }}
      value={selectedItem}
      placeholder={inputDetails.placeholder}
      onChange={(item: any) => {
        setSelectedItem(item);
        onChange(item?.id ?? "");
      }}
    />
  );
}
